import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BrandThemeContext = createContext({});

const FALLBACK = {
  primary: '173 58% 39%',
  accent: '173 50% 92%',
  background: '210 20% 98%',
};

const applyToDom = (theme) => {
  if (!theme) return;
  const root = document.documentElement;
  if (theme.primary) {
    root.style.setProperty('--primary', theme.primary);
    root.style.setProperty('--ring', theme.primary);
    root.style.setProperty('--chart-1', theme.primary);
  }
  if (theme.accent) root.style.setProperty('--accent', theme.accent);
  if (theme.background) root.style.setProperty('--background', theme.background);
};

export const BrandThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(null);
  const [audience, setAudience] = useState('default');
  const [themeKey, setThemeKey] = useState('sage_teal');

  const fetchAndApply = useCallback(async () => {
    try {
      const token = localStorage.getItem('littlelearners-token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await fetch(`${API_URL}/api/themes/current`, { headers });
      if (!res.ok) { applyToDom(FALLBACK); return; }
      const data = await res.json();
      setTheme(data.theme);
      setAudience(data.audience);
      setThemeKey(data.theme_key);
      applyToDom(data.theme);
    } catch {
      applyToDom(FALLBACK);
    }
  }, []);

  useEffect(() => {
    fetchAndApply();
    const onStorage = (e) => {
      if (e.key === 'littlelearners-token') fetchAndApply();
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [fetchAndApply]);

  return (
    <BrandThemeContext.Provider value={{ theme, audience, themeKey, refresh: fetchAndApply }}>
      {children}
    </BrandThemeContext.Provider>
  );
};

export const useBrandTheme = () => useContext(BrandThemeContext);
export default BrandThemeContext;
